import React from 'react';
import Helmet from 'react-helmet';
import ModelSerialCard from './ModelSerialCard';
import modelSerialData from './modelAndSerialData';
import LostKeyComboCallouts from '../lostKeyCombo/LostKeyComboCallouts';
import Header from '../../common/Header';
import SupportNav from '../SupportNav';
import Breadcrumb from '../../common/Breadcrumb';
import BreadcrumbItem from '../../common/BreadcrumbItem';

class FindModelSerial extends React.Component {
	render() {
		const cards = modelSerialData.map(
			(data, index) => <ModelSerialCard data={ data } key={ index } />
		);
		return (
			<div className="find-model-serial-number">
				<Helmet>
					<title>Find Your Model or Serial Number | SentrySafe</title>
					<meta name="description" content="Easily locate your model or serial number for all your support needs." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Support" path="/support" />
					<BreadcrumbItem label="Find Your Model/Serial Number" />
				</Breadcrumb>

				<SupportNav />

				<Header
					title="Find Your Model/Serial Number"
					description="SentrySafe is committed to providing you the support you need. To find your model or serial number, identify your safe type from the options below."
				/>

				<section className="section-find-model-serial-number">
					<h2 className="assistive-text">Identify Your Type of Safe Below</h2>
					<div className="section-content">
						<div className="row">
							{ cards }
						</div>
					</div>
				</section>
				<div className="support">
					<section className="section section-support-lost-key-combo">
						<header className="section-header row">
							<div className="col">
								<h2>Lost Your Key or Combination?</h2>
								<p>Select your country below to view possible retrieval methods.</p>
							</div>
						</header>
						<LostKeyComboCallouts />
					</section>
				</div>
			</div>
		);
	}
};

export default FindModelSerial;


// WEBPACK FOOTER //
// ./src/pages/support/findModelSerialNumber/Index.js